<template>
  <div>
    <div class="whiteBg">
      <el-button type="primary" plain icon="el-icon-plus" @click="addCourse">新增课程</el-button>
      <dy-table :columns="columns_" style="margin-top: 12px" :table-data="courseList" v-loading="tableLoading"
        :total="total" :page-num="pageNum" :page-size="10" @current-change="onCurrentChange"
        element-loading-text="加载中"></dy-table>
    </div>
    <studyContent ref="studyContent"></studyContent>
    <studyDialog ref="studyDialog" :_courseForm="courseForm" :_dialogTitle="dialogTitle" :labelList="labelList"
      @getList="getList"></studyDialog>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import studyContent from './studyContent';
import studyDialog from './studyDialog';

import host from '@/api/index';
import { getCourseList, getCourseInfo, courseDelete, coursePublish } from '@/api/index2';
import { pushUserType, operatingSystemPhone } from '@/utils/commonData';

export default {
  name: 'courseA',
  components: {
    DyTable,
    studyContent,
    studyDialog,
  },
  props: {
    labelList: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    uploadImg() {
      return host.uploadImgUrl;
    },
    headers() {
      return {
        'bg-token': localStorage.getItem('token'), // 直接从本地获取token就行
      };
    },
  },
  data() {
    return {
      searchForm: {},

      columns_: [],
      courseList: [],
      tableLoading: true,
      total: 0,
      pageNum: 1,
      pageSize: 10,

      pushUserType,
      operatingSystemPhone,

      dialogTitle: '新建课程',
      courseForm: {},
    };
  },
  created() {

  },
  mounted() {
    this.columns_ = [
      ...this.columns,
      {
        key: 'publishStatus',
        title: '发布状态',
        render: ({ row }) => {
          if (row.publishStatus == 2) {
            return (
              <div>
                <el-button type='warning' round size='mini'>
                  已下线
                </el-button>
              </div>
            );
          } else if (row.publishStatus == 1) {
            return (
              <div>
                <el-button type='primary' round size='mini'>
                  已发布
                </el-button>
              </div>
            );
          }
        },
      },
      {
        key: '',
        title: '操作',
        width: 300,
        render: ({ row }) => {
          if (row.publishStatus == 2) {
            return (
              <div>
                <el-link type='primary' onClick={() => this.doEdit(row)}>
                  编辑
                </el-link>
                <el-link type='warning' style='margin-left:12px' onClick={() => this.coursePublish(row)}>
                  上线
                </el-link>
                <el-link type='primary' style='margin-left:12px' onClick={() => this.chapterListDialogOpen(row)}>
                  课程内容
                </el-link>
                <el-link type='primary' style='margin-left:12px' onClick={() => this.coursePreview(row)}>
                  课程预览
                </el-link>
                <el-link type='danger' style='margin-left:12px' onClick={() => this.doDelete(row)}>
                  删除
                </el-link>
              </div>
            );
          } else if (row.publishStatus == 1) {
            return (
              <div>
                <el-link type='warning' style='margin-left:12px' onClick={() => this.coursePublish(row)}>
                  下线
                </el-link>
                <el-link type='primary' style='margin-left:12px' onClick={() => this.coursePreview(row)}>
                  课程预览
                </el-link>
              </div>
            );
          }
        },
      },
    ];
    this.getList();
  },
  methods: {
    // 新增
    addCourse() {
      this.courseForm = {};
      this.$refs.studyDialog.addVisible = true;
    },

    // 分页
    onCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },

    // 编辑
    doEdit(obj) {
      this.dialogTitle = '编辑课程';
      this.courseForm = obj;

      getCourseInfo({ id: obj.id }).then((res) => {
        this.courseForm = res.data;
        this.courseForm.labelName = this.labelList.filter((item) => new Set(JSON.parse(this.courseForm.labelName)).has(item.labelName)).map((item) => item.labelId);
        this.courseForm.userType = this.courseForm.userType.split(',');
        this.courseForm.systemType = this.courseForm.systemType.split(',');
        console.log('courseForm :>> ', this.courseForm);
      });
      this.$refs.studyDialog.addVisible = true;
    },
    // 删除
    doDelete(row) {
      this.$confirm(`确认要删除此课程吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let info = {
          id: row.id,
          isDelete: row.isDelete == 1 ? 0 : 1,
        };
        courseDelete(info).then((res) => {
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success',
          });
          this.getList();
        });
      });
    },
    // 上线/下线
    coursePublish(row) {
      let msg = '';
      if (row.publishStatus == 1) {
        msg = '下线后，推广位中该课程将不展示，是否下线？';
      } else {
        msg = '确认要上线此课程吗?';
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let info = {
          id: row.id,
          publishStatus: row.publishStatus == 1 ? 2 : 1,
        };
        coursePublish(info).then((res) => {
          if (res.result == 1) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'warning',
            });
          }
          this.getList();
        });
      });
    },

    getList(searchForm) {
      if (searchForm) {
        this.pageNum = 1;
        this.searchForm = searchForm;
      }
      let param = {
        page: this.pageNum,
        pageSize: this.pageSize,
        queryType: 1,
        type: 1,
        ...this.searchForm,
      };
      this.tableLoading = true;
      console.log('param :>> ', param);
      getCourseList(param).then((res) => {
        console.log('res :>> ', res);
        if (res.result == 1) {
          this.total = res.data.total;
          this.pageNum = res.data.pageNum;
          this.courseList = res.data.list;
          console.log('res :>> ', res.data.list);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          });
        }
        this.tableLoading = false;
      });
    },

    coursePreview(row) {
      this.$refs.studyContent.previewDialogOpen(row);
    },
    chapterListDialogOpen(row) {
      this.$refs.studyContent.chapterListDialogOpen(row);
    },
  },
};
</script>
<style scoped>
/* 图片容器居中显示 */
.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  height: 180px;
  overflow: hidden;
}

.uploaded-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 4px;
}
</style>
